import React, { useEffect, useState } from 'react';
import KraftoAdmin from './KraftoAdmin/KraftoAdminRouting';
import HtmlApp from './HtmlApp';
//import ConsumerApp from './ConsumerApp/ConsumerApp';
import './App.css';

const MainApp = () => {
  const [shouldRenderKraftoAdmin, setShouldRenderKraftoAdmin] = useState(false);
  const [shouldRenderHtmlApp, setShouldRenderHtmlApp] = useState(false);
  //const [shouldRenderconsumerapp, setShouldRenderconsumerapp] = useState(false);

  useEffect(() => {
    const path = window.location.pathname;

    // Check for specific paths first to avoid conflicts
  if (path.startsWith('/krafto')) {
      setShouldRenderKraftoAdmin(true);
    } /* else if (path.startsWith('/consumer')) {
      setShouldRenderconsumerapp(true);
    }   */   else if (path === '/') {
      setShouldRenderHtmlApp(true);
    }
  }, []); // Empty dependency array ensures this runs only once

  return (
    <>
      {shouldRenderKraftoAdmin && <KraftoAdmin />}
      {/* {shouldRenderconsumerapp && <ConsumerApp />} */}  
      {shouldRenderHtmlApp && <HtmlApp />}
    </>
  );
};

export default MainApp;
